import { IAppState } from '../../../AppModulesWrapper';
import { IPublishTermsService } from '../../types/reducers/publishTerms';
import { selectServiceById } from './selectServiceById';
import { selectActiveServiceId } from '../../reducers/v2/promotion/selectors';

export function selectActiveService(state: IAppState): IPublishTermsService | null {
  const selectedServiceId = selectActiveServiceId(state);

  if (!selectedServiceId) {
    return null;
  }

  return selectServiceById(selectedServiceId, state);
}
